const callflowQueryKeys = {
  all: ['callflow'] as const,
  list: (skip: number, take: number, sortBy: any, filters: any) =>
    [...callflowQueryKeys.all, 'list', skip, take, sortBy, filters] as const,
  byId: (id?: string) => [...callflowQueryKeys.all, id] as const,
};

export default callflowQueryKeys;
